export const setPromiseTimeout = (callback: () => void, time: number) => {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      callback();
      resolve();
    }, time);
  });
};
